<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>

    {{ data.error_message }}

    <div mat-dialog-actions>
        <button mat-button (click)="onCancel()">OK</button>
    </div>
</div>